import { defineComponent, PropType } from "vue";

import type { UserProfileMenu } from "./profileHelpers.js";

export const UserProfileNav = defineComponent({
    name: "UserProfileNav",

    props: {
        userId: {
            type: String,
            required: true,
        },
        activeMenu: {
            type: String as PropType<UserProfileMenu>,
            required: true,
        },
    },

    setup(props) {
        const items = [
            {
                key     : "overview",
                label   : "Accueil",
                icon    : "home",
                to      : () => `/users/${props.userId}`,
            },
            {
                key     : "voice",
                label   : "Voice",
                icon    : "graphic_eq",
                to      : () => `/users/${props.userId}/voice`,
            },
        ] as const;

        return () => (
            <nav class="user-profile-nav">
                {items.map((item) => {
                    const active = item.key === "voice"
                        ? props.activeMenu === "voice" || props.activeMenu === "voice_self"
                        : props.activeMenu === item.key;

                    return (
                        <router-link to={item.to()} class={{ "user-profile-nav-item": true, active }} key={item.key}>
                            <span class="material-symbols-outlined">{item.icon}</span>
                            {item.label}
                        </router-link>
                    );
                })}
            </nav>
        );
    },
});
